import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { LogoutDto } from '../types/dtos';

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
    build.mutation<void, LogoutDto>({
        query: (payload) => ({
            url: APP_ENDPOINTS.AUTH_LOGOUT,
            method: 'POST',
            body: payload,
        }),
    });
